var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAm1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.356,
    height: 22.197,
    viewBox: "0 0 21.356 22.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pool",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pool-2",
    "data-name": "pool",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M-88-139.16c0-2.909,5.039,2.909,5.039,0s5.039,2.909,5.039,0,5.039,2.909,5.039,0,5.039,2.909,5.039,0",
    transform: "translate(88 159.316)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M-80.961-169.2V-183.48A2.519,2.519,0,0,0-83.48-186h0A2.519,2.519,0,0,0-86-183.48v.84",
    transform: "translate(86.84 186)",
    fill: "none",
    stroke: "#939299",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M-54.961-169.2V-183.48A2.519,2.519,0,0,0-57.48-186h0A2.519,2.519,0,0,0-60-183.48v.84",
    transform: "translate(71.758 186)",
    fill: "none",
    stroke: "#939299",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x2: 10.454,
    transform: "translate(6.098 7.893)",
    fill: "none",
    stroke: "#939299",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 10.454,
    transform: "translate(6.098 13.12)",
    fill: "none",
    stroke: "#939299",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm1);
export default __webpack_public_path__ + "static/media/am1.c55d2cb15e1d4346f89b4dd73ec90734.svg";
export { ForwardRef as ReactComponent };